import { render, staticRenderFns } from "./NewExternalOrder.vue?vue&type=template&id=018d70b8"
import script from "./NewExternalOrder.vue?vue&type=script&lang=js"
export * from "./NewExternalOrder.vue?vue&type=script&lang=js"
import style0 from "./NewExternalOrder.vue?vue&type=style&index=0&id=018d70b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports